exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-footer[data-v-2160788a]{text-align:right}", ""]);

// exports
